import React from 'react';
import { motion } from 'framer-motion';
import { Sun, Utensils, Dumbbell, Focus } from 'lucide-react';
const modules = [{
  icon: Sun,
  title: 'El Reset Circadiano',
  description: 'Cómo usar la luz solar para disparar tu energía matutina en solo 5 minutos.'
}, {
  icon: Utensils,
  title: 'Arquitectura Nutricional Alpha',
  description: 'Cómo comer para anular el exceso de estrógeno y proteger tu testosterona, incluso en cenas de negocios.'
}, {
  icon: Dumbbell,
  title: 'La Dosis Mínima Efectiva',
  description: 'La rutina de fuerza de 15 minutos necesaria para activar la respuesta anabólica (solo 2 veces por semana).'
}, {
  icon: Focus,
  title: 'Limpieza de Dopamina',
  description: "Cómo resetear tus receptores cerebrales para recuperar el enfoque, la ambición y el 'drive' competitivo."
}];
export function WhatsInside() {
  return <section className="py-24 px-4 relative" data-id="element-136">
      <div className="max-w-5xl mx-auto" data-id="element-137">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-138">
          <span className="inline-block text-brand-orange font-bold tracking-widest text-xs md:text-sm uppercase mb-4" data-id="element-139">
            — The Alpha Protocol —
          </span>
          <h2 className="text-4xl md:text-6xl font-bold text-white uppercase mb-4" data-id="element-140">
            Lo que vas a dominar <br data-id="element-141" />
            en las próximas <span className="text-brand-orange" data-id="element-142">3 semanas</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-143">
          {modules.map((mod, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-brand-darker border border-brand-gray p-8 rounded-xl relative overflow-hidden group hover:border-brand-orange transition-colors" data-id="element-144">
              <div className="absolute top-0 right-0 w-32 h-32 bg-brand-orange/5 rounded-bl-full -mr-10 -mt-10 transition-transform group-hover:scale-110" data-id="element-145" />

              <div className="relative z-10" data-id="element-146">
                <mod.icon className="w-10 h-10 text-brand-orange mb-6" data-id="element-147" />
                <h3 className="text-2xl font-bold text-white uppercase tracking-wide mb-3" data-id="element-148">
                  {mod.title}
                </h3>
                <p className="text-brand-muted text-lg" data-id="element-149">{mod.description}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}